import { io } from 'socket.io-client';

let socket = null;

// Lazily-constructed Socket.IO connection on /ws. The backend gateway
// authenticates via the access cookie on handshake, so withCredentials must
// be true. Auto-reconnects on disconnect (socket.io's default behavior).
export function getSocket() {
  if (socket) return socket;
  const base = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';
  socket = io(`${base}/ws`, {
    withCredentials: true,
    transports: ['websocket', 'polling'],
  });
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
